// Recovered compiled webpack factory 47260. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ReadonlyURLSearchParams: function () {
        return l.ReadonlyURLSearchParams;
      },
      RedirectType: function () {
        return l.RedirectType;
      },
      ServerInsertedHTMLContext: function () {
        return u.ServerInsertedHTMLContext;
      },
      forbidden: function () {
        return l.forbidden;
      },
      notFound: function () {
        return l.notFound;
      },
      permanentRedirect: function () {
        return l.permanentRedirect;
      },
      redirect: function () {
        return l.redirect;
      },
      unauthorized: function () {
        return l.unauthorized;
      },
      unstable_isUnrecognizedActionError: function () {
        return c.unstable_isUnrecognizedActionError;
      },
      unstable_rethrow: function () {
        return l.unstable_rethrow;
      },
      useParams: function () {
        return _;
      },
      usePathname: function () {
        return p;
      },
      useRouter: function () {
        return h;
      },
      useSearchParams: function () {
        return d;
      },
      useSelectedLayoutSegment: function () {
        return g;
      },
      useSelectedLayoutSegments: function () {
        return m;
      },
      useServerInsertedHTML: function () {
        return u.useServerInsertedHTML;
      },
    }));
  let n = r(12115),
    a = r(46752),
    o = r(3865),
    i = r(26381),
    s = r(65360),
    l = r(35439),
    u = r(72103),
    c = r(12845),
    f = void 0;
  function d() {
    let e = (0, n.useContext)(o.SearchParamsContext);
    return (0, n.useMemo)(() => (e ? new l.ReadonlyURLSearchParams(e) : null), [e]);
  }
  function p() {
    return (null == f || f("usePathname()"), (0, n.useContext)(o.PathnameContext));
  }
  function h() {
    let e = (0, n.useContext)(a.AppRouterContext);
    if (null === e)
      throw Object.defineProperty(
        Error("invariant expected app router to be mounted"),
        "__NEXT_ERROR_CODE",
        { value: "E238", enumerable: !1, configurable: !0 },
      );
    return e;
  }
  function _() {
    return (null == f || f("useParams()"), (0, n.useContext)(o.PathParamsContext));
  }
  function m(e) {
    (void 0 === e && (e = "children"), null == f || f("useSelectedLayoutSegments()"));
    let t = (0, n.useContext)(a.LayoutRouterContext);
    return t
      ? (function e(t, r, n, a) {
          let o;
          if ((void 0 === n && (n = !0), void 0 === a && (a = []), n)) o = t[1][r];
          else {
            var l;
            let e = t[1];
            o = null != (l = e.children) ? l : Object.values(e)[0];
          }
          if (!o) return a;
          let u = o[0],
            c = (0, i.getSegmentValue)(u);
          return !c || c.startsWith(s.PAGE_SEGMENT_KEY) ? a : (a.push(c), e(o, r, !1, a));
        })(t.parentTree, e)
      : null;
  }
  function g(e) {
    (void 0 === e && (e = "children"), null == f || f("useSelectedLayoutSegment()"));
    let t = m(e);
    if (!t || 0 === t.length) return null;
    let r = "children" === e ? t[0] : t[t.length - 1];
    return r === s.DEFAULT_SEGMENT_KEY ? null : r;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
